module.exports = __webpack_public_path__ + "assets/Fundky_Logotype_2016._BGGeometric.jpg";